import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import { AiFillGithub, AiFillInstagram } from "react-icons/ai"
import { FaLinkedinIn } from "react-icons/fa"

const Footer = () => (
    <Container fluid className="footer">
        <Row>
            <Col md="4" className="footer-body">
                <ul className="footer-icons">
                    <li className="social-icons">
                        <a href="https://github.com/rodrigo4635" style={{ color: "white" }} target="_blank" rel="noopener noreferrer" >
                            <AiFillGithub />
                        </a>
                    </li>
                    <li className="social-icons">
                        <a href="https://www.linkedin.com/in/rodrigopasini/" style={{ color: "white" }} target="_blank" rel="noopener noreferrer" >
                            <FaLinkedinIn />
                        </a>
                    </li>
                    <li className="social-icons">
                        <a href="https://www.instagram.com/rodrigo.pasin1/" style={{ color: "white" }} target="_blank" rel="noopener noreferrer" >
                            <AiFillInstagram />
                        </a>
                    </li>
                </ul>
            </Col>
        </Row>
    </Container>
)

export default Footer